export const getTimeZoneName = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;
